module.exports = __webpack_public_path__ + "img/dos-manipulation.32d7013d.png";